<div>
    <h2>{{'historico-consumos.titulo' | translate}}</h2>
    <div class="filters-info" *ngIf="filtersVisible">{{'global.infoRequired' | translate}}</div>
    <section class="filters-framed" *ngIf="filtersVisible">
        <form [formGroup]="filtersForm" [ngClass]="{'show-warning':showWarning, 'show-error':showError}">
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.pais' | translate}} *</label>
                <app-filterable-list [itemsList]="paises" [selectedItem]="filtersForm.get('pais')" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'historico-consumos.filters.denominacion' | translate}} *</label>
                <app-filterable-list [itemsList]="denominaciones" [selectedItem]="filtersForm.get('denominacion')"
                    [disabled]="disabledDenominaciones" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'historico-consumos.filters.campanya' | translate}} *</label>
                <app-filterable-list [itemsList]="campanyas" [selectedItem]="filtersForm.get('campanya')"
                    [disabled]="disabledCampanyas" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.provincia' | translate}}</label>
                <app-filterable-list [itemsList]="provincias" [selectedItem]="filtersForm.get('provincia')"
                    [disabled]="disabledProvincias" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.municipio' | translate}} {{required ? ('*') : ('')}}</label>
                <app-filterable-list [itemsList]="municipios" [selectedItem]="filtersForm.get('municipio')"
                    [disabled]="disabledMunicipios" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'historico-consumos.filters.etiquetador' | translate}} *</label>
                <app-filterable-list [itemsList]="etiquetadores" [selectedItem]="filtersForm.get('etiquetador')"
                    [disabled]="disabledEtiquetadores" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'historico-consumos.filters.confeccion' | translate}}</label>
                <app-filterable-list [itemsList]="confecciones" [selectedItem]="filtersForm.get('confeccion')"
                    [disabled]="disabledConfecciones" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'historico-consumos.filters.marca' | translate}}</label>
                <app-filterable-list [itemsList]="marcas" [selectedItem]="filtersForm.get('marca')"
                    [disabled]="disabledMarcas" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.almacen' | translate}}</label>
                <app-filterable-list [itemsList]="almacenes" [selectedItem]="filtersForm.get('almacen')"
                    [disabled]="disabledAlmacenes" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'historico-consumos.filters.destino' | translate}}</label>
                <app-filterable-list [itemsList]="destinos" [selectedItem]="filtersForm.get('destino')" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'global.fecha.inicio' | translate}}</label>
                <input [matDatepicker]="fechaInicio" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaInicio"
                    (click)="fechaInicio.open()">
                <mat-datepicker #fechaInicio></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'global.fecha.fin' | translate}}</label>
                <input [matDatepicker]="fechaFin" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaFin"
                    (click)="fechaFin.open()">
                <mat-datepicker #fechaFin></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'historico-consumos.filters.snc' | translate}}</label>
                <input type="text" formControlName="snc">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'historico-consumos.filters.productor' | translate}}</label>
                <input type="text" formControlName="desProductor">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'"></div>
        </form>
    </section>
    <section class="filters-buttons">
        <button *ngIf="!filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.abrir' | translate}}">
            <i class="fas fa-filter"></i> {{'global.filtros.filtrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.cerrar' | translate}}">
            <i class="fas fa-times"></i> {{'global.filtros.cerrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary"
            [ngClass]="{'showFilters': filtersVisible, 'secondary-disabled': !checkValuesForm()}" (click)="resetForm()"
            title="{{'global.filtros.limpiar' | translate}}">
            <i class="fas fa-eraser"></i> {{'global.filtros.limpiar' | translate}}
        </button>
        <button *ngIf="filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            title="{{'global.filtros.filtrar' | translate}}" (click)="filtrar()">
            <i class="fas fa-filter"></i> {{'global.filtros.aplicar' | translate}}
        </button>
    </section>
    <section class="export-buttons">
      <i class="fa-solid fa-circle-question" (click)="openDocHelp()" title="{{'global.obtenerAyuda' | translate}}"></i>
    </section>
    <!-- <section class="export-buttons">
        <i class="fas fa-file-pdf" [ngClass]="{'disabled': !historicoConsumos || (historicoConsumos && historicoConsumos.length < 1) || getRolePermission()}"
            title="{{'titles.exportarPDF' | translate}}"></i>
    </section> -->
    <div class="table-wrapper">
        <div class="table-container">
            <table>
                <thead>
                    <tr>
                        <th class="icon"></th>
                        <th class="icon"></th>
                        <th class="string">{{'global.finca' | translate}}</th>
                        <th class="string">{{'global.provincia' | translate}}</th>
                        <th class="string">{{'global.municipio' | translate}}</th>
                        <th class="string">{{'historico-consumos.table.productor' | translate}}</th>
                        <th class="date sortable" (click)="toOrderBy('x=> x.FechaImpresion', 7)">
                            {{'historico-consumos.table.fechaConsumo' | translate}}
                            <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.FechaImpresion')"></i></div>
                        </th>
                        <th class="string sortable" (click)="toOrderBy('$.DesConfeccion', 8)">
                            {{'historico-consumos.table.confeccion' | translate}}
                            <div class="sortable-icons"><i [ngClass]="getIcon('$.DesConfeccion')"></i></div>
                        </th>
                        <th class="string">
                            {{'global.type' | translate}}
                        </th>
                        <th class="number sortable" (click)="toOrderBy('x=> x.numeroEtiquetasImpresasEfectivas', 9)">
                          {{'global.unidades' | translate}}
                          <div class="sortable-icons"><i [ngClass]="getIcon('x=> x.numeroEtiquetasImpresasEfectivas')"></i></div>
                        </th>
                        <th class="number">{{'historico-consumos.table.peso' | translate}}</th>
                        <th class="string">{{'historico-consumos.table.snc' | translate}}</th>
                    </tr>
                </thead>
                <tbody class="clickable" *ngFor="let historico of historicoConsumos; let i = index; trackBy: trackByConsumoId">
                    <tr (click)="showDetails(i);" [ngClass]="{'dropdownInfo': dropdownInfo === i}">
                        <td class="icon"><i [ngClass]="dropdownInfo === i ? 'fas fa-angle-down fa-sm' : 'fas fa-angle-right fa-sm'"
                            title="{{dropdownInfo === i ? ('global.minimizarInfo' | translate) : ('global.masInfo' | translate)}}"></i>
                        </td>
                        <td class="icon">
                            <i *ngIf="historico.desMarca" class="fa-solid fa-trademark fa-sm" title="{{'titles.marcaEtiquetada' | translate}}"></i>
                            <i *ngIf="!historico.denominacionIdUnica" class="fa solid fa-m fa-sm" title="{{'titles.consumoMix' | translate}}"></i>
                        </td>
                        <td class="string">{{historico.desFinca}}</td>
                        <td class="string">{{historico.desProvincia}}</td>
                        <td class="string">{{historico.desMunicipio}}</td>
                        <td class="string">{{historico.desProductor}}</td>
                        <td class="date">{{historico.fechaImpresionLocal | date:"dd/MM/yyyy H:mm:ss"}}</td>
                        <td class="string">{{historico.desConfeccion}}</td>
                        <td class="string">{{historico.tipoConfeccionId === 1 ? ('global.caja' | translate) : historico.tipoConfeccionId === 2 ? ('global.pallet' | translate) : ''}}</td>
                        <td class="number">{{historico.numeroEtiquetasImpresasEfectivas | number : '1.0-0': defaultLanguage}}</td>
                        <td class="number">{{historico.kilosImpresosEfectivos | number : '1.2-2': defaultLanguage}}</td>
                        <td class="string">{{historico.seriadoFijo}}<br>({{('0000' + historico.seriadoInicio).slice(-4)}} - {{( '0000' + historico.seriadoFin).slice(-4)}})</td>
                    </tr>
                    <tr *ngIf="dropdownInfo === i">
                        <td colspan="14">
                            <div class="detail">
                                <div class="title">{{'global.masInformacion' | translate}}</div>
                                <div class="block-inline">
                                  <label>{{'historico-consumos.table.id' | translate}}</label>
                                  <p>{{historico.consumoId}}</p>
                                </div>
                                <div class="block-inline">
                                  <label>{{'historico-consumos.table.denominacion' | translate}}</label>
                                  <p>{{historico.desDenominacion}}</p>
                                </div>
                                <div class="block-inline">
                                    <label>{{'historico-consumos.table.marca' | translate}}</label>
                                    <p>{{historico.desMarca}}</p>
                                </div>
                                <div class="block-inline">
                                    <label>{{'historico-consumos.table.licencia' | translate}}</label>
                                    <p>{{historico.nLicencia}}</p>
                                </div>
                                <div class="block-inline">
                                    <label>{{'historico-consumos.table.poligono' | translate}}</label>
                                    <p>{{historico.poligonoCatastral}}</p>
                                </div>
                                <div class="block-inline">
                                    <label>{{'historico-consumos.table.parcela' | translate}}</label>
                                    <p>{{historico.parcelaCatastral}}</p>
                                </div>
                                <div class="block-inline">
                                  <label>{{'historico-consumos.table.destino' | translate}}</label>
                                  <p>{{historico.paisDestinoISO3}}</p>
                                </div>
                                <div class="block-inline">
                                    <label>{{'historico-consumos.table.fechaConsumo' | translate}}</label>
                                    <p>{{historico.fechaConsumoUTC | date:"dd/MM/yyyy H:mm:ss"}}</p>
                                </div>
                                <div class="block-inline">
                                  <label>{{'historico-consumos.table.etiquetasReimp' | translate}}</label>
                                  <p>{{historico.numeroEtiquetasReimpresas | number : '1.0-0': defaultLanguage}}</p>
                                </div>
                                <div class="block-inline">
                                    <label>{{'historico-consumos.table.kilosReimp' | translate}}</label>
                                    <p>{{historico.kilosReimpresos | number : '1.2-2': defaultLanguage}}</p>
                                </div>
                                <div class="block-inline">
                                    <label>{{'historico-consumos.table.mix' | translate}}</label>
                                    <i *ngIf="!historico.denominacionIdUnica" class="fa-regular fa-circle-check" title="{{'titles.consumoMix' | translate}}"></i>
                                    <i *ngIf="historico.denominacionIdUnica" style="color:red" class="fa-regular fa-circle-xmark"
                                        title="{{'titles.consumoEstandar' | translate}}"></i>
                                </div>
                                <div class="block-inline"></div>
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tfoot *ngIf="!historicoConsumos || (historicoConsumos && historicoConsumos.length < 1)">
                    <tr>
                        <td colspan="13">
                            {{'global.noContent' | translate}}
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
    <app-paginator *ngIf="historicoConsumos && historicoConsumos.length > 0" [itemsPerPage]="itemsPerPage"
        [currentPage]="currentPage + 1" [totalItems]="totalItems" [visiblePages]="visiblePages"
        (pageChange)="pageChange($event)" (itemsPerPageChange)="itemsPerPageChange($event)">
    </app-paginator>
    <app-toast *ngIf="(showError || showWarning) && mensajes" [messages]="mensajes"
        (closed)="showError=$event; showWarning=$event">
    </app-toast>
</div>
